import {PollingBaseService} from '../models/polling-base-service.model';
import {forwardRef, Inject, Injectable} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';
import {UploadFileService} from './upload-file.service';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class FileManagerPollingService extends PollingBaseService {
	protected BASE_TIMER = 10000;
	private certificateUUID: string;

	constructor(@Inject(forwardRef(() => UploadFileService)) private uploadFileService: UploadFileService) {
		super();
	};

	settingPolling(certificateUUID: string, maximumAttempts: number, time?: number) {
		this.certificateUUID = certificateUUID;
		this.MAXIMUM_ATTEMPTS = maximumAttempts;
		this.attempts = 0;
		this.pollingSubject = new Subject<any>();
		this.pollingObservable = this.pollingSubject.asObservable();
		this.stopPolling();
		if (!Utilities.isVoid(time) && time > 0) {
			this.BASE_TIMER = time;
			this.startPolling(true);
		} else {
			this.startPolling();
		}
	}

	doAction() {
		if (this.attempts === this.MAXIMUM_ATTEMPTS) {
			this.attempts = 0;
			this.pollingSubject.error('error: file-manager -> maximum attempts exceeded [' + this.MAXIMUM_ATTEMPTS + ']');
		} else {
			this.attempts++;
			this.uploadFileService.pollingFile(this.certificateUUID).subscribe(
				resp => {
					this.lastResult = resp;
					this.pollingSubject.next(this.lastResult);
				}, error => {
					this.pollingSubject.error(error);
				});
		}
	}
}
